import { render, staticRenderFns } from "./InsertConcept.vue?vue&type=template&id=6ff2561c&scoped=true"
import script from "./InsertConcept.vue?vue&type=script&lang=js"
export * from "./InsertConcept.vue?vue&type=script&lang=js"
import style0 from "./InsertConcept.vue?vue&type=style&index=0&id=6ff2561c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff2561c",
  null
  
)

export default component.exports